import { PropertyTypeEnum } from '../../../shared/properties';

/**
 * Those property type are not yet supported in logic builder
 *
 * Reasons for exclusion:
 * - address: We support the nested properties (city, country, etc.) instead of the whole object
 * - banking_information: Complex object that needs special handling (tracked in E-4190)
 * - unknown: Properties with unknown types cannot be reliably used in logic
 */
export const UNSUPPORTED_PROPERTY_TYPES: PropertyTypeEnum[] = [
  PropertyTypeEnum.address, // Excluding the address property, only accept the nested one
  PropertyTypeEnum.banking_information, // @TODO - E-4190 - Client portal logic: datatype BankingInformation
  PropertyTypeEnum.unknown,
];

/**
 * Those property mapping keys are not supported in logic builder
 *
 * Reasons for exclusion:
 * - address.region: This property is redundant with address.state in many contexts
 *   and can cause confusion in logic rules
 */
export const UNSUPPORTED_PROPERTY_MAPPING_KEYS: string[] = ['address.region'];
